import { PageWrapper } from '@/Shared/ui/layout'
import { CashbackAutoenrollmentContainer } from '../organisms'

export const CashbackAutoEnrollmentPage = () => {
  return (
    <PageWrapper paddingSmaller>
      <CashbackAutoenrollmentContainer />
    </PageWrapper>
  )
}
